<template>
	<th class='pb-3 border-b border-grey-500 font-normal lg:table-cell'
		:class='[{
			"block": mobile,
			"hidden": ! mobile,
		}]'
	>
		<slot />
	</th>
</template>

<script>
	export default {
		props: {
			mobile: { type: Boolean, default: false },
			index: { type: Number, default: null },
		},

		created() {
			this.hidden = ! this.visable
		},

		data() {
			return {
				hidden: this.visable
			}
		},	

		watch: {
			visable() {
				setTimeout(() => {
					this.hidden = ! this.visable;
				}, this.visable ? 500 : 0)
			}
		},

		computed: {
			user() {
				return this.$parent.user;
			},

			visable() {
				if (this.name == null) {
					return true;
				}
				
				if (this.$parent.page.user == undefined 
					|| this.$parent.page.user.columns == undefined
				) {
					return false;
				}

				return this.$parent.page.user.columns[this.name]
			},
		}
	}
</script>